/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemCodeBody
 */
export interface RedeemCodeBody {
    /**
     * The promo code to redeem
     * @type {string}
     * @memberof RedeemCodeBody
     */
    code: string;
    /**
     * The quest config ID
     * @type {string}
     * @memberof RedeemCodeBody
     */
    questConfigId: string;
    /**
     * The milestone ID within the quest
     * @type {string}
     * @memberof RedeemCodeBody
     */
    milestoneId: string;
}

/**
 * Check if a given object implements the RedeemCodeBody interface.
 */
export function instanceOfRedeemCodeBody(value: object): value is RedeemCodeBody {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('questConfigId' in value) || value['questConfigId'] === undefined) return false;
    if (!('milestoneId' in value) || value['milestoneId'] === undefined) return false;
    return true;
}

export function RedeemCodeBodyFromJSON(json: any): RedeemCodeBody {
    return RedeemCodeBodyFromJSONTyped(json, false);
}

export function RedeemCodeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemCodeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'questConfigId': json['questConfigId'],
        'milestoneId': json['milestoneId'],
    };
}

export function RedeemCodeBodyToJSON(json: any): RedeemCodeBody {
    return RedeemCodeBodyToJSONTyped(json, false);
}

export function RedeemCodeBodyToJSONTyped(value?: RedeemCodeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'questConfigId': value['questConfigId'],
        'milestoneId': value['milestoneId'],
    };
}

